//Common CSS for bottom nav buttons on mobile
export const LAYOUT_CONSTANTS = {
  maxPageWidth: "1440px",
  maxContentWidth: "1300px",
  maxFormWidth: "626px",
  modalDialogWidth: 572,
} as const;

//Common CSS for bottom nav buttons on mobile
export const BOTTOM_NAV_MOBILE_CSS = {
  width: "100%", // Ensure it spans the full width of the screen
  position: "fixed",
  bottom: 0,
  left: 0,
  backgroundColor: "$app.color.surface.container.secondary", // Optional: Add a background color to avoid overlap issues
  boxShadow: "0 8px 24px -2px rgba(0, 0, 0, 0.16)", // Optional: Add a shadow for better visibility
  padding: "16px 16px 8px", // Optional: Add padding for better spacing
  zIndex: 100, // Ensure it stays above other elements
  gap: "16px",
  border: "1px solid $app.color.default.border",
};

export const HEADER_MOBILE_HEIGHT = "20px"; // Height of the header on mobile in pixels
